<template>
  <v-dialog v-model="localDialog" scrollable width="854" lazy>
    <v-card>
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title>
          {{
            localPhase._id
              ? $t('titles.global.updateModel', { field: $tc('models.phase') })
              : $t('titles.global.newAModel', { field: $tc('models.phase') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="localPhase.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex md3 xs12 px-2>
            <v-switch
              v-model="localPhase.showResults"
              :label="$t('titles.tournaments.ifShowResults')"
              color="primary"
            />
          </v-flex>
          <v-flex v-if="type === 'teams'" md3 xs12>
            <v-switch
              v-model="localPhase.randomMatches"
              :label="$t('titles.tournaments.ifRandomMatches')"
              color="primary"
            />
          </v-flex>
          <v-flex md2 xs12 px-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="hour"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template #activator="{ on }">
                <v-text-field
                  v-model="hour"
                  :label="$t('fields.global.time')"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="menu"
                v-model="hour"
                full-width
                @click:minute="$refs.menu.save(hour)"
              />
            </v-menu>
            <v-btn v-if="hour" small color="success" @click="addHour()">
              {{
                $t('titles.global.addField', {
                  field: $t('fields.global.time'),
                })
              }}
            </v-btn>
          </v-flex>

          <v-flex md4 xs12 px-2>
            <v-chip
              v-for="(hour, index) in localPhase.hours"
              :key="1100 + index"
              color="primary"
              dark
              close
              @input="removeHour(index)"
            >
              {{ hour }}
            </v-chip>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex md3 xs12 px-2>
                <v-radio-group
                  v-model="localPhase.typePlayOff"
                  :label="$t('fields.phases.typePlayOff') + ' *'"
                >
                  <v-radio
                    color="primary"
                    :label="$t('titles.phases.ranking')"
                    value="ranking"
                  />
                  <v-radio
                    v-if="type === 'teams'"
                    color="primary"
                    :label="$t('titles.phases.winners')"
                    value="winners"
                  />
                </v-radio-group>
              </v-flex>
              <template v-if="localPhase.typePlayOff === 'ranking'">
                <v-flex md4 xs12 px-2>
                  <v-text-field
                    v-model.number="localPhase.toClass"
                    v-validate="`min_value:1|max_value:${maxToClass}`"
                    type="number"
                    :label="$t('fields.phases.toClass')"
                    min="1"
                    :max="maxToClass"
                    step="1"
                    maxlength="2"
                    :data-vv-name="$t('fields.phases.toClass')"
                    :error-messages="
                      errors.collect($t('fields.phases.toClass'))
                    "
                  />
                </v-flex>
                <v-flex md4 xs12 px-2>
                  <v-text-field
                    v-model.number="localPhase.matchesByParticipant"
                    v-validate="`min_value:1`"
                    type="number"
                    :label="$t('fields.phases.matchesByParticipant')"
                    min="1"
                    max="10"
                    step="1"
                    maxlength="2"
                    :data-vv-name="$t('fields.phases.matchesByParticipant')"
                    :error-messages="
                      errors.collect($t('fields.phases.matchesByParticipant'))
                    "
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
          <v-flex md2 xs4 px-2>
            <v-switch
              v-model="localPhase.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <template>
          <span style="color: red">(*) &nbsp;</span>
          <span>{{ $t('action.messages.fieldRequired') }}</span>
        </template>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button type="cancel" @click="cancel" />
        <meta-button
          v-if="!localPhase._id"
          type="create"
          :loading="loading"
          @click="submit"
        />
        <meta-button v-else type="update" :loading="loading" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TranslationField from '@/components/widgets/Input/TranslationField'

export default {
  name: 'DialogPhase',
  components: { TranslationField },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
    },
    maxToClass: {
      type: Number,
      default: 1,
      required: false,
    },
    phase: {
      type: Object,
      default: () => {},
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hour: '',
      menu: false,

      entityId: '',
      searchEntity: '',
      searchTeam: '',
      searchUser: '',
    }
  },
  watch: {
    'localPhase.typePlayOff': function (newVal /* , oldVal */) {
      if (newVal !== 'ranking') {
        this.localPhase.matchesByParticipant = 1
        this.localPhase.toClass = Math.round(this.maxToClass / 2)
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({
      teamSelectList: 'teams/selectList',
      userSelectList: 'users/selectList',
      entitySelectList: 'entities/selectList',
    }),
    localDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        if (!value) this.cancel()
      },
    },
    localPhase: {
      get() {
        return this.phase
      },
      set(value) {
        this.$emit('update:phase', value)
      },
    },
  },
  methods: {
    ...mapActions({
      reset: 'phases/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return
          this.$emit('submit')
        }
      )
    },
    addHour() {
      this.localPhase.hours.push(this.hour)
      this.hour = null
    },
    removeHour(index) {
      this.localPhase.hours.splice(index, 1)
    },
    clear() {
      this.$nextTick(() => {
        this.reset()
        this.entityId = ''
        this.$refs.name.$validator.reset()
        this.$validator.reset()
      })
    },
    cancel() {
      this.$emit('update:dialog', false)
      this.clear()
    },
  },
}
</script>
